/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import { Grid } from '@mui/material';
import { FC, useCallback, useRef } from 'react';
import RESOURCES from '~/resources';
import { EActionEvent, ECategoryEvent, useEvents } from '~/hooks/useEvents';
import { useLeadLocation } from '~/hooks/useLeadLocation';
import useLOBContacData from '~/hooks/useLOBContacData';
import useLineOfBusinessTarget from '~/hooks/useLineOfBusinessTarget';
import { useContactUsPopup } from '~/hooks/useContactUsPopup';
import { EContactUsFlow } from '~/data/ContactUsPopup/enums';
import { useCurrentCar } from '~/hooks/useCurrentCar';
// import { ButtonStyles } from '../ContactUsPopup/useStyles';
import PeopleIcon from '~/assets/icons/jsx/PhoneGray';
import Button from '../Button';
import { BUTTON_SIZES, BUTTON_TYPES } from '~/data/constants';
import ConversationGrayIcon from '~/assets/icons/jsx/ConversationGrayIcon';
import { useStyles } from './useStyles';
interface IContactUsView {
  showWhatsapp?: boolean;
  showPhone?: boolean;
  showLeaveDetails?: boolean;
}

const ContactUsInlineOption: FC<IContactUsView> = ({
  showWhatsapp = true,
  showPhone = true,
  showLeaveDetails = true,
}) => {
  const events = useEvents();
  const { sourceLocation, category } = useLeadLocation();
  const lineOfBusinessTarget = useLineOfBusinessTarget();
  const { whatsappLink, phoneNumber } = useLOBContacData();
  const { openContactUsModal } = useContactUsPopup();
  const car = useCurrentCar();
  const callLinkRef = useRef<HTMLAnchorElement>(null);
  const styles = useStyles();
  const onClickWhatApps = useCallback(() => {
    events.sendEvent(
      {
        action: `${EActionEvent.CONTACT_US_MODAL_WHATSAPP}`,
        category: category,
      },
      {
        leadLocation: sourceLocation,
        businessLine: lineOfBusinessTarget,
      },
    );
    window.open(whatsappLink, '_blank');
  }, [events, sourceLocation, category, whatsappLink, lineOfBusinessTarget]);

  const handleLeaveDetailsClick = useCallback(() => {
    events.sendEvent(
      {
        category: ECategoryEvent.LEAD,
        action: EActionEvent.LEAD_LOAD,
      },
      {
        leadLocation: sourceLocation,
        businessLine: lineOfBusinessTarget,
      },
    );

    openContactUsModal({
      flow: EContactUsFlow.LEAVE_DETAILS,
    });
  }, [events, sourceLocation, lineOfBusinessTarget, openContactUsModal]);

  const onClickPhone = useCallback(() => {
    events.sendEvent(
      {
        action: EActionEvent.CONTACT_US_MODAL_CALL_US,
        category: category,
      },
      {
        leadLocation: sourceLocation,
        businessLine: lineOfBusinessTarget,
        carModel: car?.modelNameDisplayName ?? car?.dmvModelName,
        carBrand: car?.manufacturerDisplayName ?? car?.dmvManufacturerName,
      },
    );

    if (callLinkRef.current) {
      callLinkRef.current.click();
    }
  }, [events, sourceLocation, category, lineOfBusinessTarget, car]);

  return (
    <Grid container sx={styles.containerStyle}>
      <a
        href={`tel:${phoneNumber}`}
        ref={callLinkRef}
        style={styles.phoneWrapperStyle}
      >
        Call
      </a>

      {showPhone && (
        <Grid item xs={2}>
          <Button
            aria-label={RESOURCES.CAR_FLOW_SUMMARY_CALL_US}
            onClickFunc={onClickPhone}
            size={BUTTON_SIZES.SMALL}
            type={BUTTON_TYPES.TRANSPARENT}
            label={RESOURCES.CAR_FLOW_SUMMARY_CALL_US}
            icon={<PeopleIcon />}
            typographyStyle={styles.typographyStyle}
            customStyle={styles.customStyle}
          />
        </Grid>
      )}

      {showLeaveDetails && (
        <Grid item xs={3}>
          <Button
            aria-label={RESOURCES.CAR_FLOW_SUMMARY_CALL_ME}
            onClickFunc={handleLeaveDetailsClick}
            size={BUTTON_SIZES.SMALL}
            type={BUTTON_TYPES.TRANSPARENT}
            label={RESOURCES.CAR_FLOW_SUMMARY_CALL_ME}
            icon={<ConversationGrayIcon />}
            typographyStyle={styles.typographyStyle}
            customStyle={styles.customStyle}
          />
        </Grid>
      )}

      {showWhatsapp && (
        <Grid item xs={3}>
          <Button
            ariaLabel={RESOURCES.CONTACT_US_WHATSAPP_REVERSE}
            onClickFunc={onClickWhatApps}
            size={BUTTON_SIZES.SMALL}
            type={BUTTON_TYPES.TRANSPARENT}
            label={RESOURCES.CONTACT_US_WHATSAPP_POPUP}
            typographyStyle={styles.typographyStyle}
            customStyle={styles.customStyle}
            icon={<ConversationGrayIcon />}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default ContactUsInlineOption;
